export const containerCss = {
  display: "flex",
  gap: "10px",
};
